import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import React, { FC, useState } from 'react';
import { useOrdering } from '../../../stores/OrderingStore';
import { LayoutVariant } from '../../Core/CommonTypes';
import KeyboardField from '../../Core/KeyboardField/KeyboardField';

interface Props {
  variant?: LayoutVariant;
}

const TableTent: FC<Props> = () => {
  const [open, setOpen] = useState(true);
  const [value, setValue] = useState<string>('');
  const orderingStore = useOrdering();
  const order = orderingStore.order;
  const handle = () => {
    order.table_tent = parseFloat(value);
    setOpen(false);
  };

  return (
    <Dialog open={open}>
      <DialogTitle>Please select a table tent and input here</DialogTitle>
      <DialogContent>
        <KeyboardField
          autoFocus
          margin="dense"
          value={value}
          handleValueChange={v => setValue(v)}
          textField
          type="number"
          fullWidth
          keyboard={{
            enable: true,
            layout: {
              default: ['1 2 3 4 5 6 7 8 9 0 {bksp}']
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={!value} onClick={handle} color="primary">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TableTent;
